"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mixins_1 = require("../theme/mixins");

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper"); // @TODO костыль так как 2kit не полностью перешел на новый paradigm.tokens


var layoutWidthTablet = 768;

exports.styles = function (theme) {
  return __assign(__assign({
    panel: __assign(__assign({}, mixins_1.border(theme)), {
      boxShadow: theme.depth1,
      borderRadius: theme.sizeBorderRadiusPaper,
      backgroundColor: theme.colorBgPopup.normal,
      margin: '0 auto',
      position: 'relative',
      minWidth: 320,
      width: '100%',
      display: 'block'
    }),
    wrapper: {
      padding: theme.x4 + "px " + theme.paddingBase + "px " + theme.paddingBase + "px"
    },
    small: {
      maxWidth: theme.sizePopupSmall
    },
    normal: {
      maxWidth: theme.sizePopupMedium
    },
    large: {
      maxWidth: theme.sizePopupLarge
    },
    infinity: {
      maxWidth: 'none'
    },
    'exact-size': {
      '&$small': {
        width: theme.sizePopupSmall
      },
      '&$normal': {
        width: theme.sizePopupMedium
      },
      '&$large': {
        width: theme.sizePopupLarge
      }
    },
    cross: {
      float: 'right',
      margin: '22px 18px 18px',
      cursor: 'pointer',
      fill: theme.colorIcon.normal
    },
    'cross-small': {
      margin: theme.x3
    },
    popup: {
      border: 'none',
      boxShadow: 'none'
    },
    promo: {
      textAlign: 'center'
    },
    plug: {
      width: 52,
      height: 56,
      float: 'left'
    },
    iframe: {
      position: 'absolute',
      width: 0,
      border: 'none',
      height: '100%',
      minHeight: 50
    }
  }, mobileStylesHelper_1.default({
    border: 'none',
    boxShadow: 'none',
    margin: '0 auto',
    '& $wrapper': {
      padding: theme.x4
    },
    '& $cross:not($mobileCross), & $plug': {
      display: 'none'
    },
    '&$small:not($popup)': {
      maxWidth: layoutWidthTablet
    },
    '&$popup': {
      minWidth: 320 - 2 * theme.x2
    }
  })), {
    content: {},
    mobileCross: {}
  });
};